module.exports = __webpack_public_path__ + "img/img1-bg.59628fd9.png";